import { render, staticRenderFns } from "./MortgageApplicationStoppedPopup.vue?vue&type=template&id=5a1b3d15&scoped=true&"
import script from "./MortgageApplicationStoppedPopup.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationStoppedPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b3d15",
  null
  
)

export default component.exports